import { render, staticRenderFns } from "./JurusanTable.vue?vue&type=template&id=b5e16eb6&"
import script from "./JurusanTable.vue?vue&type=script&lang=js&"
export * from "./JurusanTable.vue?vue&type=script&lang=js&"
import style0 from "./JurusanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports